import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {  LoginUser } from '../_models';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  
  Url=environment.ApiUrl +"auth";
  constructor(private http: HttpClient) { }

   authDetails(id: string) {
    return  this.http.get<LoginUser>(`${this.Url}/authenticate/${id}?`);
  } 

  authToken()
  {
    const headerDict = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin' : '*',
    }
    const body = new HttpParams()
    .set('grant_type', "client_credentials")
    .set('client_id', "0606835c-645a-402c-969c-bad06128a26c")
    .set('client_secret', "YIS26JFE/hcfJEXYbzG7R2QT9KDpNZmrBH0N9ubwdoA=")
    .set('resource', "https://chevron.onmicrosoft.com/sams");
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post('https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/oauth2/token',body,{ headers, observe: 'response' });
  }

  appToken(){
    return  this.http.get<any>(`${this.Url}/apptoken`);
  }
}
